export const routes = [
  {
    path: '/cassa/home',
    name: 'CassaHome',
    component: () => import(/* webpackChunkName: "cassaHome" */ '../views/cassa/home'),
    meta: {
      layout: 'Cassa'
    }
  },  
  {
    path: '/cassa/fatture-elettroniche',
    name: 'CassaFattureElettroniche',
    component: () => import(/* webpackChunkName: "cassaFattureElettroniche" */ '../views/cassa/fattureElettroniche'),
    meta: {
      layout: 'Cassa'
    }
  },
  {
    path: '/cassa/menu-composti/:idmenu/:chiave?',
    name: 'CassaMenuComposti',
    component: () => import(/* webpackChunkName: "menuComposti" */ '../views/cassa/menuComposti'),
    props: true,
    meta: {
      layout: 'Cassa'
    }
  },
  {
    path: '/cassa/clienti/dettaglio/:idCliente',
    name: 'CassaClientiDettaglio',
    component: () => import(/* webpackChunkName: "cassaClientiDettaglio" */ '../views/cassa/clienti/dettaglio'),
    props: true,
    meta: {
      layout: 'Cassa'
    }
  },
  {
    path: '/cassa/variazioni/:idProdotto/:chiave?',
    name: 'CassaVariazioni',
    component: () => import(/* webpackChunkName: "varianti" */ '../views/cassa/variazioni'),
    props: true,
    meta: {
      layout: 'Cassa'
    }
  },
  {
    path: '/cassa/buoni-pasto/:chiave?',
    name: 'CassaBuoniPasto',
    component: () => import(/* webpackChunkName: "buoniPasto" */ '../views/cassa/buoniPasto'),
    props: true,
    meta: {
      layout: 'Cassa'
    }
  },
  {
    path: '/cassa/lavorazioni/:chiave?',
    name: 'CassaLavorazioni',
    component: () => import(/* webpackChunkName: "lavorazioni" */ '../views/cassa/lavorazioni'),
    props: true,
    meta: {
      layout: 'Cassa'
    }
  },
  {
    path: '/cassa/scambiodati/:chiave?',
    name: 'CassaScambioDati',
    component: () => import(/* webpackChunkName: "scambioDati" */ '../views/cassa/scambioDati'),
    props: true,
    meta: {
      layout: 'Cassa'
    }
  }
]
